import React, { useState, useEffect } from 'react';
import * as actionTypes from "@redux/actionTypes";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import Inprogress from '@images/dashboard/inProgressBot.png';
import OfflineBot from '@images/dashboard/offlineBot.png';
import VerifiedBot from '@images/dashboard/verifiedBot.png';
import Online from '@images/dashboard/onlineBot.png';
import { safeLocalStorage } from '@utils/localstorage';

const getInitialBotStatus = (token) => {
    if (token && token.user && (token.user.has_test_drive || token.user.kyc_id)) {
        return {
            mission_ready: true,
            mission_in_progress: true,
            offline: true,
        };
    } else {
        return {
            mission_ready: true,
            mission_in_progress: true,
            offline: true,
            verified: true,
        };
    }
};

const getBotStatusData = (token) => {
    if (token && token.user && (token.user.has_test_drive || token.user.kyc_id)) {
        return [
            {
                image: Online,
                botStatus: 'Online',
                label: 'mission_ready',
            },
            {
                image: Inprogress,
                botStatus: 'In-progress',
                label: 'mission_in_progress',
            },
            {
                image: OfflineBot,
                botStatus: 'Offline',
                label: 'offline',
            },
        ]
    } else {
        return [
            {
                image: Online,
                botStatus: 'Online',
                label: 'mission_ready',
            },
            {
                image: Inprogress,
                botStatus: 'In-progress',
                label: 'mission_in_progress',
            },
            {
                image: OfflineBot,
                botStatus: 'Offline',
                label: 'offline',
            },
            {
                image: VerifiedBot,
                botStatus: 'Verified Only',
                label: 'verified',
            },
        ]
    }
}

const BotStatus = () => {
    const dispatch = useDispatch();
    const allBot = useSelector((state) => state.botDetail.allBot);
    const token = safeLocalStorage.getItem('token')
    const [stausCheck, setStausCheck] = useState(() => getInitialBotStatus(token));
    const [botStatusData] = useState(() => getBotStatusData(token))

    useEffect(() => {
        if (allBot.length > 0) {
            const missionReadyBots = allBot.filter(bot => bot.status === 'mission_ready');
            if (missionReadyBots.length >= 3) {
                setStausCheck({ ...stausCheck, offline: false });
                const status = {
                    checked: { ...stausCheck, offline: false },
                };
                dispatch({
                    type: actionTypes.STATUS_DETAILS,
                    payload: status
                });
            }
        }
    }, [allBot]);

    const checkBoxHandler = (checked, name) => {
        setStausCheck({ ...stausCheck, [name]: checked });
        const status = {
            checked: { ...stausCheck, [name]: checked },
        };
        dispatch({
            type: actionTypes.STATUS_DETAILS,
            payload: status,
        });
    };

    return (
        <div className='flex w-[200px] p-[16px] flex-col justify-center items-start gap-[8px] rounded-[16px] bg-[rgba(255,_255,_255,_0.85)]'>
            <div className='w-full flex items-center gap-[4px]'>
                <p className='text-[#4B4B4B] text-center text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>Legend</p>
            </div>
            {
                botStatusData.map((status, index) => (
                    <div className='w-full flex items-center' key={index}>
                        <Checkbox
                            borderColor={status.label ? "#2D74FF" : "#898989"}
                            borderRadius={4}
                            icon={
                                <div
                                    style={{
                                        backgroundColor: "#2D74FF",
                                    }}
                                >
                                    <Icon.FiCheck color="white" size={18} />
                                </div>
                            }
                            checked={stausCheck[status.label]}
                            onChange={(e) => checkBoxHandler(e, status.label)}
                            size={22}
                            style={{ cursor: "pointer" }}
                            labelStyle={{
                                marginRight: "6px",
                                fontFamily: "Space Grotesk",
                                fontStyle: "normal",
                                fontWeight: "500",
                                fontSize: "16px",
                                lineHeight: "23px",
                                letterSpacing: "-0.32px",
                                color: "#4B4B4B",
                            }}
                            className="checkLabel"
                            label={
                                <div className='w-full flex items-center gap-[6px]'>
                                    <div>
                                        <img
                                            src={status.image}
                                            alt={status.botStatus}
                                            className='w-[32px] h-[32px]'
                                        />
                                    </div>
                                    <p>{status.botStatus}</p>
                                </div>
                            }
                        />
                    </div>
                ))
            }
        </div>
    )
}

export default BotStatus